import {
  Component,
  Prop,
  Element,
  h,
  Listen,
  Host,
  Watch,
} from '@stencil/core';
import { SearchResponseEntry } from '../../../../../../types/global'; // eslint-disable-line import/extensions
import store from '../../../../../global/store';

export type FormParams = {
  /* eslint-disable max-len, camelcase */
  snippet: string; // "<div data-webforms-id=\"/formulare/snippets/full/bank_search_beratungsanfrage_form\"></div>"
  _lang: string; // "de_DE"
  formRevisionNr: string; // "34778"
  audience: string; // "UIP"
  valid_to: string; // ""
  name: string; // "Kontaktanfrage Ansprechpartnersuche"
  valid_from: string; // "03.06.2019"
  revisionNr: string; // "35584"
  _id: string; // "bank_search_beratungsanfrage_form"
  _fd: string; // "f3GiQLmoGhNMZCzKD6B7NIR4C3QHlNazRCK..."
  /* eslint-enable max-len, camelcase */
};

@Component({
  tag: 'ui-bank-search-webform-general',
  styleUrl: 'ui-bank-search-webform-general.scss',
  shadow: false,
})
export class UiBankSearchWebformGeneral {
  @Element() el: HTMLUiBankSearchWebformGeneralElement;

  @Prop() bank: SearchResponseEntry;

  @Prop() formUrl: string;
  // @Prop() formUrl: string = `${window.location.origin}/formulare/servlet/form.html`;

  /**
   * FormID is defined in Magnolia Environments and provided to component.
   * magnolia.dev.azure.union-investment.de will provide a different ID than
   * magnolia.prod.azure.union-investment.de
   */
  // @Prop() formId = '';
  // @Prop() formId = 428170; // form for bankensuche on "Abnahme"
  // @Prop() formId = 487146; // form for bankensuche on "Prod"
  @Prop() formId = 'bank_search_beratungsanfrage_form';

  @Prop() formApiKey = 'afc6d9beb9c640abbdc5975f8b3deb42';

  @Prop({ mutable: true }) finalPageActive = false;

  private formParams: FormParams = null;

  /**
   * Passed on to ui-cms-webforms for use as first item in VirtualContentGroup for tracking calls
   * See ui-cms-webforms for details.
   */
  trackingAttributes = {
    virtualContentGroups: ['app_filialsuche'],
  };

  cmsWebforms: HTMLElement;

  @Listen('uiCmsWebformsClose', { target: 'body' })
  onFormClose() {
    this.reset();
  }

  componentWillLoad() {
    this.onFormIdChange();
  }

  @Watch('formId')
  onFormIdChange() {
    this.fetchFormParams();
  }

  /**
   * fetch params including '_fd' which is necessary for requests to the API
   */
  async fetchFormParams() {
    const response = await fetch(
      `${window.location.origin}/formulare/snippets/placeholder/${this.formId}`
    );
    this.formParams = await response.json();
    store.state.formName = this.formParams.name;
  }

  @Watch('bank')
  onBankChange() {
    this.appendFormHTML();
    // ! UMAGDXC-1128 requires NO tracks to be fired when ASPS initializes.
    // ! DON'T call tracker.trackInitialFormPage() here!
  }

  componentDidLoad() {
    this.appendFormHTML();
  }

  appendFormHTML() {
    // prevent request from sending when no formParams exist
    if (!this.formParams) return;
    /* eslint-disable no-underscore-dangle */
    const fd = this.formParams?._fd;
    const formRevisionNr = this.formParams?.formRevisionNr;
    const revisionNr = this.formParams?.revisionNr;

    const formLanguage = this.formParams?._lang.split('_')[1] || ''; // "de_DE" → "DE"
    const formUID = `${formLanguage}${this.formParams?._id}`; // DEbank_search_beratungsanfrage_form

    // reasonably 'unique' ID to point jQuery.mwfAjaxReplace to the correct container
    const ajaxReplaceID = `mwf-ajax-replace-${Math.random().toString().replace('0.', '')}`;

    // snippet source: https://formulare-integration.union-investment.de/formulare/snippets/full/283225
    this.cmsWebforms.innerHTML = `
    <div class="mwf-form">
      <div id="${ajaxReplaceID}">
        <script type="text/javascript">
          var ready = window.ui?.webforms?.registerCallback || jQuery('document').ready;
          window.ui = window.ui || {};

          ready(function ($) {

            function getResolution() {
              return(screen.width * window.devicePixelRatio) + 'x' + (screen.height * window.devicePixelRatio);
            }

            function getQueryVariable(variable) {
              let query = window.location.href.substring(window.location.href.indexOf('?') + 1);
              if (query.indexOf('#') > 0) {
                query = query.substring(0, query.indexOf('#'));
              }
              let vars = query.split("&");
              for (var i = 0; i < vars.length; i++) {
                let pair = vars[i].split("=");
                if (pair[0] == variable) {
                  return pair[1];
                }
              }
            }

            let params_string = '';
            let entryValue = '';

            entryValue = getQueryVariable('_reset');
            if (typeof entryValue !== 'undefined') {
              params_string += '&' + '_reset=' + entryValue;
            }

            entryValue = getQueryVariable('inputText');
            if (typeof entryValue !== 'undefined') {
              params_string += '&' + 'inputText=' + entryValue;
            }

            entryValue = getQueryVariable('blz');
            if (typeof entryValue !== 'undefined') {
              params_string += '&' + 'blz=' + entryValue;
            }

            entryValue = getQueryVariable('plz');
            if (typeof entryValue !== 'undefined') {
              params_string += '&' + 'plz=' + entryValue;
            };

            try {
              let webTrekkEnabled = typeof ui !== 'undefined' && ui.configuration.webtrekk && ui.configuration.webtrekk.enabled && ui.configuration.webtrekk.initData && '0' !== ui.configuration.webtrekk.initData.form;
              if (! webTrekkEnabled) {
                params_string += '&webtrekkDisabled=true';
              }
            } catch (ex) {
              if (console) {
                console.error("webtrekk-error: " + ex.message);
              }
            }

            jQuery.noConflict();
            jQuery.mwfAjaxReplace({
              uid: '${formUID}',
              selector: '#${ajaxReplaceID}',
              url: '${this.constructFormUrlFrom()}',
              query: 'audience=UIP&formRevisionNr=${formRevisionNr}&revisionNr=${revisionNr}&resolution=' + getResolution() + params_string,
              appendUrlVars: true,
              data: {
                _view: 'webform',
                _fd: '${fd}',
                _refs: '',
                _lang: 'de_DE',
                _ticket: ''
              }
            });

          });
        </script>
        <span class="loading">
          <sd-spinner style="font-size: 2rem" color="primary"></sd-spinner>
          ${(window as any).ui.services?.i18n?.translate('bankSearch').loadingForm || 'Lade Formular...'}
        </span>
      </div>
    </div>`;
    // eslint-disable-next-line no-eval
    eval(this.cmsWebforms.querySelector('script').innerHTML);
  }

  constructFormUrlFrom(): string {
    const url = new URL(
      this.formUrl
        ? this.formUrl
        : `${window.location.origin}/formulare/servlet/form?`
    );
    url.searchParams.append('bank', String(this.bank?.bankCode));
    url.searchParams.append('bankname', encodeURI(this.bank?.name));
    url.searchParams.append('_reset', 'true');
    return url.href.toString();
  }

  reset() {
    this.appendFormHTML();
  }

  render() {
    return (
      <Host>
        <ui-cms-webforms
          ref={(el) => {
            this.cmsWebforms = el;
          }}
          webformsJsUrl="/formulare/3.0.0/js/webforms_pk.min.js"
          parentTrackingAttributes={this.trackingAttributes}
        ></ui-cms-webforms>
      </Host>
    );
  }
}
